import SearchIcon from '../Icons/menu-vtv/search';
import HomeIcon from '../Icons/menu-vtv/home';
import LiveTVIcon from '../Icons/menu-vtv/livetv';
import ProfileIcon from '../Icons/menu-vtv/profile';
import MoviesIcon from '../Icons/menu-vtv/movies';
import MyListIcon from '../Icons/menu-vtv/watchlist';
import CardiVIcon from '../Icons/menu-vtv/cardiv';

//добавить пункт меню Видео

export default {
  SEARCH: SearchIcon,
  HOME: HomeIcon,
  LIVE_TV: LiveTVIcon,
  VOD: MoviesIcon,
  CARDI_V: CardiVIcon,
  MY_WATCHLIST: MyListIcon,
  PROFILE: ProfileIcon,
  SCREEN: MoviesIcon,
};
